import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_KB_GATEWAY}`,
  headers: {
    'Access-Control-Allow-Origin': '*',
    "Content-Type": "application/json"
  },
});

export const setKbBaseURL = (url) => {
  instance.defaults.baseURL = url;
};


export default instance;
